function openTabFeed(evt, sectionId, tabName) {
  // get all elements with class="tabcontent" and hide them except the first one
  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );

  var target = document.getElementsByClassName(tabName)[0];

  console.log(document.getElementsByClassName(tabName))

  scrollTo(target);

  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // get all elements with class="tablinks" and remove the class "active" except the first one
  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(
      " active",
      ""
    );
  }

  // show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

function scrollTo(target) {
  var parent = getImmediateScrollableParent(target);

  // We check if target is a valid DOM element. 
  // Because of reasons, this function gets called when target is not a valid DOM element
  // resulting in the mobile drawer menu not hiding 
  if (target instanceof Element) {
    const targetRect = target.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    const offsetLeft = targetRect.left - parentRect.left + parent.scrollLeft;

    let scrollPosition = offsetLeft - (parent.clientWidth / 2) + (target.clientWidth / 2);

    const maxScroll = parent.scrollWidth - parent.clientWidth;

    scrollPosition = Math.max(0, Math.min(scrollPosition, maxScroll));

    parent.scrollTo({
      left: scrollPosition,
      behavior: "smooth"
    });
  }
}

function getImmediateScrollableParent(element) {
  let parent = element.parentElement;
  while (parent) {
    // Check if parent has horizontal scroll (overflow-x)
    const style = window.getComputedStyle(parent);
    if (['auto', 'scroll'].includes(style.overflowX)) {
      return parent; // Found the immediate scrollable parent
    }
    parent = parent.parentElement; // Move up to next parent
  }
  return null; // No scrollable parent found (will fall back to viewport)
}

// show the first tabs by default on load - data-default-open
document.querySelectorAll("[data-default-open]").forEach(el => {
  el.click();
});
window.addEventListener("shopify:section:load", () => {
  document.querySelectorAll("[data-default-open]").forEach(el => {
    el.click();
  });
});
